import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { formatPrice } from '@weft/services';
import type { LineItemPromotion } from '@weft/types';
import type { Currency } from '@weft/types';
import { formatNumber } from '@weft/utils';
import React from 'react';
import { getPromotionConfigDefaultValue } from '../../../../../hooks/use-promotions-config-default-value';
import { generatePromotionTitle, getAmountByType, getCalculationByType } from '../../../../../services/promotions-formatter';

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: '1px',
    borderBottomColor: '#E8F2F8',
    paddingHorizontal: '17px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '3px',
    paddingVertical: '9px',
  },
  namePriceContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  name: {
    fontSize: '14px',
    color: '#292D32',
    fontWeight: 500,
  },
  description: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#A3ACBD',
  },
  price: {
    fontSize: '14px',
    color: '#292D32',
    fontWeight: 500,
  },
});

type FixedProductLineItemProps = {
  lineItemPromotion: LineItemPromotion;
  currency: Currency;
  chargedAmount: number;
  promotionsAmount: number;
};

export const PromotionLineItem: React.FC<FixedProductLineItemProps> = ({ lineItemPromotion, currency, chargedAmount, promotionsAmount }) => {
  const { name, promotionModel, deductedAmount } = lineItemPromotion;
  const { promotionType, promotionConfiguration } = promotionModel;
  const amount = getPromotionConfigDefaultValue(promotionConfiguration, promotionType);

  const price = getCalculationByType(promotionType, chargedAmount - promotionsAmount + deductedAmount);
  const units = getAmountByType(promotionType, amount);

  return (
    <View
      style={styles.container}
      wrap={false}
    >
      <View style={styles.namePriceContainer}>
        <Text style={styles.name}>{name}</Text>
        <Text style={styles.price}>{formatPrice(-deductedAmount, currency)}</Text>
      </View>

      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontSize: '12px',
          fontWeight: 400,
          color: '#A3ACBD',
        }}
      >
        <Text>{generatePromotionTitle(promotionType, amount)}</Text>
        <Text>{`${formatNumber(units, 3)} X ${formatPrice(price, currency)}`}</Text>
      </View>
    </View>
  );
};